// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customTooltip__V3zY1 {
  font-family: "Roboto";
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;
  color: #222222;
  padding: 8px;
  max-width: 245px;
  background: #fff;
  border-radius: 4px;
  position: relative;
  filter: none !important;
  -webkit-filter: none !important;
}

.customTooltipClose__mE8h7 {
  position: absolute;
  top: 8px;
  right: 8px;
  cursor: pointer;
}
.customTooltipClose__mE8h7 svg {
  width: 8px;
  height: 8px;
}
.customTooltipClose__mE8h7 svg path {
  stroke: #797f89;
  fill: #797f89;
}

.customTooltipTitle__sugNC {
  padding: 2px 0 8px 0;
  max-width: 209px;
  font-size: 16px;
  font-weight: bold;
}

.customTooltipContent___eTik {
  padding: 2px 10px 8px 0;
  width: 100%;
  max-width: 245px;
}

.customTooltipText__A8JaG {
  max-width: 200px;
}

.customTooltipFooter__oGSNn {
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #ebedf1;
  margin-top: 0;
  padding: 8px 0 0;
  font-size: 13px;
  font-weight: 400;
  color: #545454;
}

.customTooltipButtons__ONFLK {
  display: flex;
  gap: 15px;
}

.customTooltipCounter__Cpa4T {
  display: flex;
  align-items: center;
  font-size: 14px;
}

.customTooltipArrow__ghMQ7 {
  width: 15px;
  height: 15px;
}

.back__dXJEs {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.back__dXJEs svg {
  transform: rotate(180deg);
}
.back__dXJEs:hover {
  height: 30px;
  width: 30px;
  background: rgba(0, 0, 0, 0.0392156863);
  border-radius: 50%;
}

.next__SkZVr {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.next__SkZVr:hover {
  height: 30px;
  width: 30px;
  background: rgba(0, 0, 0, 0.0392156863);
  border-radius: 50%;
}`, "",{"version":3,"sources":["webpack://./../src/components/Onboarding/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;EACA,+BAAA;AAzEF;;AA4EA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;AAzEF;AA0EE;EACE,UAAA;EACA,WAAA;AAxEJ;AAyEI;EACE,eAAA;EACA,aAAA;AAvEN;;AA4EA;EACE,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAzEF;;AA4EA;EACE,uBAAA;EACA,WAAA;EACA,gBAAA;AAzEF;;AA4EA;EACE,gBAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,8BAAA;EACA,6BAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,SAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,YAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAzEF;AA2EE;EACE,yBAAA;AAzEJ;AA4EE;EACE,YAAA;EACA,WAAA;EACA,uCAAA;EACA,kBAAA;AA1EJ;;AA8EA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AA3EF;AA6EE;EACE,YAAA;EACA,WAAA;EACA,uCAAA;EACA,kBAAA;AA3EJ","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.customTooltip {\n  font-family: 'Roboto';\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 20px;\n  text-align: left;\n  color: #222222;\n  padding: 8px;\n  max-width: 245px;\n  background: #fff;\n  border-radius: 4px;\n  position: relative;\n  filter: none !important;\n  -webkit-filter: none !important;\n}\n\n.customTooltipClose {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  cursor: pointer;\n  svg {\n    width: 8px;\n    height: 8px;\n    path {\n      stroke: #797f89;\n      fill: #797f89;\n    }\n  }\n}\n\n.customTooltipTitle {\n  padding: 2px 0 8px 0;\n  max-width: 209px;\n  font-size: 16px;\n  font-weight: bold;\n}\n\n.customTooltipContent {\n  padding: 2px 10px 8px 0;\n  width: 100%;\n  max-width: 245px;\n}\n\n.customTooltipText {\n  max-width: 200px;\n}\n\n.customTooltipFooter {\n  display: flex;\n  justify-content: space-between;\n  border-top: 1px solid #ebedf1;\n  margin-top: 0;\n  padding: 8px 0 0;\n  font-size: 13px;\n  font-weight: 400;\n  color: #545454;\n}\n\n.customTooltipButtons {\n  display: flex;\n  gap: 15px;\n}\n\n.customTooltipCounter {\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n}\n\n.customTooltipArrow {\n  width: 15px;\n  height: 15px;\n}\n\n.back {\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n\n  svg {\n    transform: rotate(180deg);\n  }\n\n  &:hover {\n    height: 30px;\n    width: 30px;\n    background: #0000000a;\n    border-radius: 50%;\n  }\n}\n\n.next {\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n\n  &:hover {\n    height: 30px;\n    width: 30px;\n    background: #0000000a;\n    border-radius: 50%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"customTooltip": `customTooltip__V3zY1`,
	"customTooltipClose": `customTooltipClose__mE8h7`,
	"customTooltipTitle": `customTooltipTitle__sugNC`,
	"customTooltipContent": `customTooltipContent___eTik`,
	"customTooltipText": `customTooltipText__A8JaG`,
	"customTooltipFooter": `customTooltipFooter__oGSNn`,
	"customTooltipButtons": `customTooltipButtons__ONFLK`,
	"customTooltipCounter": `customTooltipCounter__Cpa4T`,
	"customTooltipArrow": `customTooltipArrow__ghMQ7`,
	"back": `back__dXJEs`,
	"next": `next__SkZVr`
};
module.exports = ___CSS_LOADER_EXPORT___;
